jQuery(document).ready(function(){

jQuery('.country-selector').click(function(event){
  document.body.style.top = '-' + window.scrollY + 'px';
  document.body.style.position = 'fixed';
  jQuery('html').addClass('o-hidden-y');
  
  jQuery('.country-selector-popup').removeClass('right-open');
  jQuery('.country-selector-popup').removeClass('right');
   setTimeout(function(){ 
  jQuery('.country-selector-popup').addClass('open');
}, 100);

  event.preventDefault();
  event.stopPropagation();
}); 
  
jQuery('[href="#country-selector"]').click(function(event){
  document.body.style.top = '-' + window.scrollY + 'px';
  document.body.style.position = 'fixed';
  jQuery('html').addClass('o-hidden-y');
  jQuery('.country-selector-popup').addClass('right');
  setTimeout(function(){ 
    jQuery('.country-selector-popup').addClass('open');
    jQuery('.country-selector-popup').addClass('right-open');
  }, 100);

  event.preventDefault();
  event.stopPropagation();
});   
  
  
jQuery('[href="#county-selector"]').click(function(event){
  jQuery('html').addClass('o-hidden-y');
  jQuery('.country-selector-popup').addClass('right');
  setTimeout(function(){ 
    jQuery('.country-selector-popup').addClass('open');
    jQuery('.country-selector-popup').addClass('right-open');
  }, 100);
  
  event.stopPropagation();
});   
  
  
jQuery('svg.close-button').click(function(){
  jQuery('html').removeClass('o-hidden-y');
  jQuery('.country-selector-popup').removeClass('open');
  jQuery('.country-selector-popup').removeClass('right-open');
  
  document.body.style.position = '';
  window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
  document.body.style.top = '';
}); 

jQuery('.popup-container ul li').click(function(){
  jQuery('.popup-container ul li').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('.country-selector-popup').removeClass('open');
  jQuery('.country-selector-popup').removeClass('right-open');
  jQuery('.country-selector b').eq(0).html(jQuery(this).text());
  jQuery('.country-selector b').eq(1).html(jQuery(this).text());

  jQuery('html').removeClass('o-hidden-y');
  jQuery('.country-selector-popup').removeClass('open');
  jQuery('.country-selector-popup').removeClass('right-open');
  
  document.body.style.position = '';
  window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
  document.body.style.top = '';
}); 
  
  
jQuery(window).click(function() {
  jQuery('html').removeClass('o-hidden-y');
  jQuery('.country-selector-popup').removeClass('open');
  jQuery('.country-selector-popup').removeClass('right-open');
});

jQuery('html').click(function(e) {
  if (jQuery('html').hasClass("o-hidden-y")) {
    document.body.style.position = '';
    window.scrollTo(0, +document.body.style.top.replace('px', '') * -1);
    document.body.style.top = '';
  }
})

  
  jQuery('.country-selector-popup').click(function(event){
    event.stopPropagation();
}); 
  var accCols = jQuery('.grid.desktop > .grid__item');
  for(var i = accCols.length - 2; i >= 0 ; i--){
    var acc = accCols.eq(i);
    var title = acc.find('.footer__title').eq(0).html();
    var content = acc.find('.collapsible-content').eq(0).html();
    jQuery('.footer-accordion-links').eq(0).prepend(jQuery('<div class="footer-accordion-wrapper"><span class="acc-title">'+title+'</span><div class="acc-content">'+content+'</div></div>'));
  }
  
  jQuery('.social-media-links').eq(0).append(jQuery('ul.no-bullets.site-footer__linklist.CONNECT').clone())
  jQuery('.footer-accordion-wrapper').click(function(){
  jQuery(this).toggleClass('open');
}); 
    
  jQuery('.social-media-links li').click(function(){
  window.location.href = jQuery(this).find('a').attr('href');
}); 
        
});

$(document).ready(function() {
  setTimeout(function() {
    $('.legal-links #ot-sdk-btn').text('COOKIE PREFERENCES');
    $('.legal-links #ot-sdk-btn-mobile').text('COOKIE PREFERENCES');
  }, 500);

  let shippingCountries = [...document.querySelectorAll('.js-shipping-country')];

  shippingCountries.forEach(function(country) {
    country.addEventListener('click', function(e) {
      e.preventDefault();

      if (e.target.dataset.href.includes('uk')) {
        if(e.target.parentNode.parentNode.parentNode.parentNode.className.includes('right')){
           dataLayer.push({ 'event': 'shipping_country_UK_header' });
        }
        else{
           dataLayer.push({ 'event': 'shipping_country_UK_footer' });
        }
       
      }
      else {
        if(e.target.parentNode.parentNode.parentNode.parentNode.className.includes('right')){
          dataLayer.push({ 'event': 'shipping_country_global_header' });
        }

        else{
          dataLayer.push({ 'event': 'shipping_country_global_footer' });
        }
        
      }

      setTimeout(function() {
        window.location.href = e.target.dataset.href + window.location.pathname;;
      }, 200);
    });
  });
});
